// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1jRHW","imageUploader":"EGiftCard_imageUploader__XY8DZ"};